import * as EventListener from "events";

export const LogoutListener = new EventListener();

export function emitLogout(zendeskView) {
  LogoutListener.emit("logout", zendeskView);
}
